export default defineNuxtPlugin({
  name: 'content-preview',
  setup: async () => {
    const { configApiDomains: { cmsBaseUrl }, enableFContentProxy } = useFeatureFlags()
    const { cmsApiRoutePrefix, isDev } = useRuntimeConfig().public
    const { isPreview, isDisablePreview, previewDateTime } = useCms()
    const previewDateTimeCookie = useCookie('previewDateTime')

    if (isPreview && previewDateTime)
      previewDateTimeCookie.value = previewDateTime
    else if (isDisablePreview)
      previewDateTimeCookie.value = null

    if (!isPreview) return

    const { sliderMetadata } = await import('#content/config/preview')
    const url = isDev || enableFContentProxy ? cmsApiRoutePrefix : cmsBaseUrl

    useHead({
      bodyAttrs: {
        'data-cm-metadata': JSON.stringify(sliderMetadata)
      },
      script: [{
        key: 'cms-preview',
        src: `${url}/preview/static/coremedia.preview.js`
      }]
    })
  }
})
